import { Injectable, ErrorHandler } from "@angular/core";
import { ErrorLogService } from "../error-handling/error-log.service";

// global error handler that utilizes the above created service (ideally in its own file)
@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor(
    private errorLogService: ErrorLogService,) {super();}

  handleError(error:any) {
    //console.log("there is an error" + error.message);
    //console.log(error);
    this.errorLogService.logError(error);
  }
}
